module.exports = __webpack_public_path__ + "static/media/43.0e686e3d.jpg";